module.exports = __webpack_public_path__ + "img/one.5796943a.svg";